import { SchedulerGridRow } from '../row';
import { useSchedulerContext } from '@contexts/scheduler';

export const SchedulerGridWithoutTeam = () => {
  const {
    data: {
      grouped: { withoutTeam },
    },
  } = useSchedulerContext();

  const defaultForeman = { id: '', fullName: '', draggable: true, droppable: true };

  if (!withoutTeam) return null;

  if (!withoutTeam?.length)
    return <SchedulerGridRow data={[]} foreman={defaultForeman} first last withoutTeam />;

  return withoutTeam.map((group, i) => (
    <SchedulerGridRow
      key={`scheduler-grid-without-team-row-${i}`}
      data={group}
      foreman={defaultForeman}
      first={Boolean(!i)}
      last={i === withoutTeam.length - 1}
      withoutTeam
    />
  ));
};
